// Inventory Outlets Vuex

import state from './outletStates.js'
import * as getters from './outletGetters.js'
import * as mutations from './outletMutations.js'
import * as actions from './outletActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
